import React from 'react';
import PaginationNav from './PaginationNav';
import PaginationProvider from './PaginationProvider';
import usePagination from '../utils/usePagination';

var Pagination = function Pagination(props) {
  var pagination = usePagination(props);
  return /*#__PURE__*/React.createElement(PaginationProvider, pagination.options, /*#__PURE__*/React.createElement(PaginationNav, null));
};

export default Pagination;